import React from "react";

export default function UnsubscribeIcon() {
  return (
    <svg
      id="Icon_-_Unsubscribe"
      data-name="Icon - Unsubscribe"
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
    >
      <path
        id="Path_10610"
        data-name="Path 10610"
        d="M6,9.2v1.6h8V9.2ZM10,2a8,8,0,1,0,8,8A8,8,0,0,0,10,2Zm0,14.4A6.4,6.4,0,1,1,16.4,10,6.408,6.408,0,0,1,10,16.4Z"
        transform="translate(-2 -2)"
        fill="currentColor"
      />
    </svg>
  );
}
